import { useTranslations } from 'next-intl';
import { NoticePanel } from '@/components/ui/notice-panel';
import { licenseCopyKey, type Section } from '@/lib/product-sections';

interface LicenseNoticeProps {
  /**
   * Which part of the shop this product belongs to. Ammunition states a
   * different requirement from a firearm — "uppvisad originallicens och giltig
   * legitimation" rather than a licence or purchase permit (p.9 vs p.2) — so
   * the wording is chosen per section.
   */
  section: Section;
}

/**
 * The accent-bordered notice under the buy button, shown when
 * `th_licenspliktig` says the product may only be handed over against a valid
 * weapon licence.
 *
 * Kept out of the accordion on purpose: it is a condition of the purchase, so
 * it has to be visible before the customer adds the product, not folded away
 * behind a heading.
 *
 * The cart draws the same panel with its own copy — see
 * components/cart/cart-license-notice.tsx.
 */
export function LicenseNotice({ section }: LicenseNoticeProps) {
  const t = useTranslations('product.license');

  return <NoticePanel title={t('title')}>{t(licenseCopyKey(section))}</NoticePanel>;
}
